import { useState } from "react";
import { Play } from "lucide-react";

export const VideoPlayer = ({ item, autoplay = false }) => {
  const src = autoplay ? `${item.embed_url}${item.embed_url.includes("?") ? "&" : "?"}autoplay=1` : item.embed_url;
  return (
    <iframe
      src={src}
      title={item.title}
      loading="lazy"
      className="absolute inset-0 h-full w-full"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
  );
};

export const VideoCard = ({ item, index }) => {
  const [play, setPlay] = useState(!item.thumbnail_url);
  return (
    <article className="group overflow-hidden rounded-3xl border border-purple-500/25 bg-[var(--km-card)] transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[var(--km-pink)]" data-testid={`portfolio-card-${index}`}>
      <div className="relative aspect-video bg-black">
        {play ? (
          <VideoPlayer item={item} autoplay={!!item.thumbnail_url} />
        ) : (
          <button onClick={() => setPlay(true)} className="absolute inset-0" aria-label={`شغّل ${item.title}`} data-testid={`portfolio-play-btn-${index}`}>
            <img src={item.thumbnail_url} alt={item.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <span className="absolute inset-0 grid place-items-center bg-black/30">
              <span className="grid h-16 w-16 place-items-center rounded-full bg-[var(--km-pink)] text-white shadow-[0_0_30px_rgba(155,59,240,0.7)] transition-transform duration-300 group-hover:scale-110">
                <Play className="h-7 w-7 -scale-x-100 fill-white" />
              </span>
            </span>
          </button>
        )}
      </div>
      <div className="p-5">
        {item.category && <span className="font-head mb-2 inline-block rounded-full bg-[var(--km-purple)]/40 px-3 py-0.5 text-xs font-semibold text-[var(--km-lilac)]">{item.category}</span>}
        <h3 className="font-head text-xl font-bold text-white">{item.title}</h3>
        {item.description && <p className="mt-1 text-sm leading-relaxed text-purple-200/80">{item.description}</p>}
      </div>
    </article>
  );
};
